import axios, { AxiosError } from "axios"
import { LIST_PATH, PASSWORD_PATH, USER_PATH } from "../../constants/paths"
import {
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
} from "interceptors"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CREDENTIALS_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getUsersService = async () => {
  try {
    const result = await instance.get(USER_PATH + LIST_PATH)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const createUserService = async (User: any) => {
  try {
    const result = await instance.post(USER_PATH, User)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const deleteUserService = async (id: any) => {
  try {
    const result = await instance.delete(USER_PATH + `/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const editUserService = async (id: number, User: any) => {
  try {
    const result = await instance.put(USER_PATH + `/${id}`, User)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const changePasswordService = async (id: number, User: any) => {
  try {
    const result = await instance.put(
      USER_PATH + `/${id}` + PASSWORD_PATH,
      User
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data.message)
  }
}
